export default __webpack_public_path__ + "alberta-sort-next-visit-future.ee40da7ed59755c73638.svg";